import React, { useState } from "react";
import { Menu } from "@mui/material";
import { Icon } from "../Component";

export const MoreOptions = ({ options }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [activeSubOptions, setActiveSubOptions] = useState([]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null);
    setActiveSubOptions([]);
  };

  const handleSubMenuOpen = (event, subOptions) => {
    setSubmenuAnchorEl(event.currentTarget);
    setActiveSubOptions(subOptions);
  };

  const handleSubMenuClose = () => {
    setSubmenuAnchorEl(null);
    setActiveSubOptions([]);
  };

  return (
    <div className="text-soft">
      <a
        aria-haspopup="true"
        onClick={handleClick}
        className="text-soft btn btn-icon btn-trigger"
        style={{ cursor: "pointer" }}
      >
        <Icon name="more-v" />
      </a>

      <Menu
        id="main-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{ style: { minWidth: 160 } }}
        className="link-list-opt no-bdr text-secondary"
      >
        {options.map((item, index) => {
          if (item.hide === true) return null;

          if (item.subOptions && item.subOptions.length > 0) {
            return (
              <div key={index}>
                <a
                  href={undefined}
                  tabIndex={index}
                  role="menuitem"
                  className="dropdown-item w-min-140px"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubMenuOpen(e, item.subOptions);
                  }}
                >
                  <Icon name={item.icon} />
                  <span className="ms-2">{item.text}</span>

                  <Icon name="chevron-right" className={"ms-2"} />
                </a>
              </div>
            );
          }

          return (
            <div key={index}>
              <a
                href={undefined}
                tabIndex={index}
                role="menuitem"
                className="dropdown-item w-min-140px"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  handleClose();
                  item.action?.();
                }}
              >
                <Icon name={item.icon} />
                <span className="ms-2">{item.text}</span>
              </a>
            </div>
          );
        })}
      </Menu>

      {/* Submenu */}
      <Menu
        id="submenu"
        anchorEl={submenuAnchorEl}
        keepMounted
        open={Boolean(submenuAnchorEl)}
        onClose={handleSubMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          style: { minWidth: 160, marginLeft: 5 },
        }}
        className="link-list-opt no-bdr text-secondary"
      >
        {activeSubOptions.map((subItem, subIndex) => (
          <div key={subIndex}>
            <a
              href={undefined}
              tabIndex={subIndex}
              role="menuitem"
              className="dropdown-item w-min-140px"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                handleClose();
                subItem.action?.();
              }}
            >
              <Icon name={subItem.icon} />
              <span className="ms-2">{subItem.text}</span>
            </a>
          </div>
        ))}
      </Menu>
    </div>
  );
};
